@let ref = get(coloredBlockRow, 'colored_block.colored_block_reference.page_ref[0]', null);

@if (ref) {
    <section id="colored-block-section-ref">
        <div>
            <div
                class="container d-flex justify-content-center color-block colored-block container-fluid"
                [ngStyle]="{
                    'background-color': get(coloredBlockRow, 'colored_block.colored_block_reference.background_theme.color', ''),
                    'background-repeat': 'no-repeat',
                }"
            >
                <div class="grid partial-grid justify-content-between">
                    <div class="g-col-12 g-col-md-6 order-md-2 p-0 img-block-container">
                        <img [src]="backgroundDesignUrl" class="block-img-bkg" />
                        <img [src]="getWebpImg(get(ref, 'colored_block_partial.image_url', ''))" class="block-img" />
                    </div>
                    <div class="g-col-12 g-col-md-6 order-md-1 fx-col-v-center text-content-padding">
                        <h5 class="color-block-label mb-base">{{ get(ref, 'colored_block_partial.label', '') }}</h5>
                        <h2 class="mb-3">{{ get(ref, 'colored_block_partial.colored_block_header', '') }}</h2>
                        <div [innerHtml]="get(ref, 'colored_block_partial.copy', '') | safe: 'html'" class="copy-content"></div>
                        <a [routerLink]="getLinkUrl(get(ref, 'routerLink', ''))" class="align-self-start">
                            <button-component
                                [buttonOptions]="{
                                    text: get(ref, 'colored_block_partial.button_text', 'Learn More'),
                                    type: 'tertiary',
                                    iconPosition: 'right',
                                    iconName: 'chevron-right',
                                    class: 'mt-3',
                                    innerTabIndex: -1,
                                }"
                            ></button-component>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
}

@if (get(coloredBlockRow, 'colored_block.colored_block_reference.custom_url.image_url', false)) {
    @let custom = get(coloredBlockRow, 'colored_block.colored_block_reference.custom_url', null);
    <section id="colored-block-section-custom">
        <div>
            <div
                class="container d-flex justify-content-center color-block colored-block container-fluid"
                [ngStyle]="{
                    'background-color': get(coloredBlockRow, 'colored_block.colored_block_reference.background_theme.color', ''),
                    'background-repeat': 'no-repeat',
                }"
            >
                <div class="grid partial-grid justify-content-between">
                    <div class="g-col-12 g-col-md-6 order-md-2 p-0 img-block-container">
                        <img [src]="backgroundDesignUrl" class="block-img-bkg" />
                        <img [src]="getWebpImg(get(custom, 'image_url', ''))" class="block-img" />
                    </div>
                    <div class="g-col-12 g-col-md-6 order-md-1 fx-col-v-center text-content-padding">
                        <h5 class="color-block-label mb-base">{{ get(custom, 'label', '') }}</h5>
                        <h2 class="mb-3">{{ get(custom, 'colored_block_header', '') }}</h2>
                        <div [innerHtml]="get(custom, 'copy', '') | safe: 'html'" class="copy-content"></div>
                        <a [routerLink]="get(custom, 'url.routerLink', '')" class="align-self-start">
                            <button-component
                                [buttonOptions]="{
                                    text: get(custom, 'url.title', 'Learn More'),
                                    type: 'tertiary',
                                    iconPosition: 'right',
                                    iconName: 'chevron-right',
                                    class: 'mt-3',
                                    innerTabIndex: -1,
                                }"
                            ></button-component>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
}

@if (get(coloredBlockRow, 'colored_block.colored_block', []).length) {
    <section id="colored-block-section-inline">
        @for (row of get(coloredBlockRow, 'colored_block.colored_block', []); track row) {
            <div>
                <div
                    class="container d-flex justify-content-center color-block colored-block container-fluid"
                    [ngStyle]="{
                        'background-color': get(row, 'exxcom_color_picker', ''),
                        'background-repeat': 'no-repeat',
                    }"
                >
                    <div class="grid partial-grid justify-content-between">
                        <div class="g-col-12 g-col-md-6 order-md-2 p-0 img-block-container">
                            <img [src]="backgroundDesignUrl" class="block-img-bkg" />
                            <img [src]="getWebpImg(get(row, 'image.href', ''))" class="block-img" />
                        </div>
                        <div class="g-col-12 g-col-md-6 order-md-1 fx-col-v-center text-content-padding">
                            <h5 class="color-block-label mb-base">{{ get(row, 'label', '') }}</h5>
                            <h2 class="mb-3">{{ get(row, 'headline', '') }}</h2>
                            <div [innerHtml]="get(row, 'copy', '') | safe: 'html'" class="copy-content"></div>
                            <!-- Marketo Form Button -->
                            @if (get(row, 'marketo_form_selection.form_selection', '') !== 'no_form') {
                                @if (get(row, 'marketo_form_selection.form_selection', '') == 'default_form') {
                                    <button-component
                                        data-cy="marketo-form"
                                        (click)="
                                            solutionID &&
                                                bootstrapMarketoService.openBootstrapMarketoDialog(solutionID, 'edit', {
                                                    title: dataTitle,
                                                    url: dataUrl,
                                                })
                                        "
                                        [buttonOptions]="{
                                            text: get(row, 'link.title', ''),
                                            type: 'tertiary',
                                            iconPosition: 'right',
                                            iconName: 'chevron-right',
                                            class: 'mt-3 ',
                                            disabled: !solutionID,
                                        }"
                                    ></button-component>
                                }
                                @if (get(row, 'marketo_form_selection.form_selection', '') == 'other_form') {
                                    <button-component
                                        data-cy="marketo-form"
                                        (click)="
                                            get(row, 'marketo_form_selection.marketo_forms.id', '') &&
                                                bootstrapMarketoService.openBootstrapMarketoDialog(
                                                    get(row, 'marketo_form_selection.marketo_forms.id', ''),
                                                    'edit',
                                                    {
                                                        title: dataTitle,
                                                        url: dataUrl,
                                                    }
                                                )
                                        "
                                        [buttonOptions]="{
                                            text: get(row, 'link.title', ''),
                                            type: 'tertiary',
                                            iconPosition: 'right',
                                            iconName: 'chevron-right',
                                            class: 'mt-3 ',
                                            disabled: !get(row, 'marketo_form_selection.marketo_forms.id', ''),
                                        }"
                                    ></button-component>
                                }
                            }
                            <!-- RouterLink Button -->
                            <a [routerLink]="get(row, 'link.routerLink', '/')" [queryParams]="get(row, 'link.queryParams', '')">
                                @if (get(row, 'link.routerLink', '') !== '' && get(row, 'marketo_form_selection.form_selection', '') === 'no_form') {
                                    <button-component
                                        [buttonOptions]="{
                                            text: get(row, 'link.title', ''),
                                            type: 'tertiary',
                                            iconPosition: 'right',
                                            iconName: 'chevron-right',
                                            class: 'mt-3 ',
                                            innerTabIndex: -1,
                                        }"
                                    ></button-component>
                                }
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        }
    </section>
}
